import { api, getCsrf } from './User'
import { getLocalData, setLocalData } from './LocalData'

const LOCAL_DATA_KEY = '20240828_history'

export const addHistory = async (isSignIn: boolean, articleId: string) => {
  if (isSignIn) {
    const token = await getCsrf()
    const headers = { 'X-CSRF-Token': token }
    await api.post('/articles/history', { article: articleId }, { headers })
    return
  }

  const historyArticleIds = await getHistory(isSignIn)
  const index = historyArticleIds.indexOf(articleId)

  if (index !== -1) {
    historyArticleIds.splice(index, 1)
  }
  historyArticleIds.unshift(articleId)
  setLocalData(LOCAL_DATA_KEY, historyArticleIds.join(','))
}

export const getHistory = async (isSignIn: boolean) => {
  if (isSignIn) {
    const response = await api.get<{ articles: string[] }>('/articles/history')
    return response.data.articles
  }

  const localData = getLocalData(LOCAL_DATA_KEY)
  return localData === undefined || localData === '' ? [] : localData.split(',')
}

export const deleteHistory = async () => {
  const token = await getCsrf()
  const headers = { 'X-CSRF-Token': token }
  await api.delete('/articles/history', { headers })
}
